import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const AnalyticsInsightReportFeedbackSchema_ = z.object({
  userId: zExt.objectId(),
  feedback: z.enum(["positive", "negative"]),
  comment: z.string().optional(),
});
